import { Injectable } from '@odinjs/odin';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../../constants/application-endpoints';
import { Value } from '@philips-internal/oswald-ui-core';

@Injectable
export default class PseudonymAppointmentsQuizAnswerViewService {

  static quizAnswerCache = new Map<number, Array<Record<string, Value>>>();

  public clearCache(): void {
    if (PseudonymAppointmentsQuizAnswerViewService.quizAnswerCache.size > 0) {
      PseudonymAppointmentsQuizAnswerViewService.quizAnswerCache = new Map<number, Array<Record<string, Value>>>();
    }
  }

  async getQuizAnwserMetadata(parameters: Record<string, Value>): Promise<Array<Record<string, Value>>> {
    const quizReturn = await HttpService.get(APPLICATION_ENDPOINTS.GET_QUIZ_ANWSER_METADATA, parameters).then(anwser => {
      const bodyAnwser = anwser.body as Array<Record<string, Value>>;

      if (bodyAnwser.length === 0) {
        return {} as Array<Record<string, Value>>;
      }
      return bodyAnwser;
    });
    return quizReturn;
  }
}
